import { render, staticRenderFns } from "./ForgotPasswordResetForm.vue?vue&type=template&id=be54b7fa&"
import script from "./ForgotPasswordResetForm.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordResetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports